import {NgModule} from '@angular/core';
import {Scan3dCommonModule} from './common/scan3dCommon.module';
import {Scan3dGroupModule} from './scanGroup/scan3dGroup.module';
@NgModule({
    imports: [
        Scan3dCommonModule,
        Scan3dGroupModule,
    ]
})
export class Scan3dModule {}

